<template>
	<nav class="navbar navbar-light navbar-vertical navbar-expand-xl">
		<div
			class="collapse navbar-collapse mt-xl-7"
			:class="[navTopSwitch]"
			id="navbarVerticalCollapse"
		>
			<div class="navbar-vertical-content scrollbar">
				<ul
					class="navbar-nav flex-column mb-3 fs-0"
					id="navbarVerticalNav"
				>
					<li class="nav-item">
						<div
							class="row navbar-vertical-label-wrapper mt-3 mb-2"
						>
							<div
								class="col-auto navbar-vertical-label lh-base ff-ch"
								>Pages</div
							>
							<div class="col ps-0">
								<hr class="mb-0 navbar-vertical-divider" />
							</div>
						</div>

						<router-link
							v-for="(item, index) in menu"
							:key="'nav-' + index"
							:to="item.url"
							class="nav-link ff-ch text-500"
						>
							<div class="d-flex align-items-center mt-2">
								<span class="nav-link-text lh-base">{{
									item.name
								}}</span>
							</div>
						</router-link>
					</li>
				</ul>
			</div>
		</div>
	</nav>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";

export default {
	computed: {
		...mapGetters(["menu", "navTopSwitch"]),
		current() {
			return this.$route.name;
		},
	},

	mounted() {
		const vm = this;
		$(".nav-link").click(function() {
			if (window.innerWidth <= 1200) {
				vm.$store.commit("navTopSwitch", "");
			}
		});
	},
};
</script>

<style lang="scss" scoped>
.router-link-active {
	color: rgb(65, 105, 178) !important;
}
.nav-link:hover {
	color: rgb(65, 105, 178) !important;
}
</style>
